// extracted by mini-css-extract-plugin
module.exports = {"container":"richtext_container__Ieqyo"};